import React from 'react';
import { observer } from 'mobx-react';
import PageComponent from "js/components/pages/PageComponent";
import AppUser from "js/stores/AppUser";
import AppContent from "js/components/AppContent";
import {makeRequest, navigate, url} from "js/services/Network";
import Constraint from "js/components/Constraint";
import FormState from 'js/stores/forms/LoginSignupDialogForm';
import { AvForm, AvGroup, AvInput, AvFeedback, AvField } from 'availity-mobx-reactstrap-validation';
import Button from 'js/components/common/Button';
import ErrorDisplay from "js/components/common/ErrorDisplay";
import {Link} from "@reach/router";
import {lightGrey1Color} from "js/config/style";
import {Spring} from "react-spring";
import ItemsList from "js/components/pages/PspItemsPage/ItemsList";
import PartnerSellerPageState from "js/stores/pages/PartnerSellerPageState";
import BottomScrollListener from "react-bottom-scroll-listener";
import {pick} from "lodash";

const offset = '0.25rem';

@observer
export default class LearnMorePage extends PageComponent {
  pageName = 'LearnMorePage';
  trackingName = 'SP_partner_seller_learn_more';
  loginRequired = false;
  timerId = null;

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      readMore: true,
      errorMessage: null,
      sellerId: null,
      alias:null,
    };
  }


  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  copyUrl = () => {
    navigator.clipboard.writeText(this.page.micro_store);
    this.setState({clicked: true});

    if(this.timerId) {
      clearTimeout(this.timerId);
    }

    setTimeout(() => {
      this.setState({clicked: false});
    }, 5000);
  };

  // bootstrap = () => this.page.load().then(() => {/*analytics.page('My Items Page')*/});


  redirect = (link,props,params) => navigate(url(link,props,params));

  buttonCTA = (cta,link) => {
    // console.log("link:",link, "pspData:",this.state.pspData.micro_store)
    this.redirect(link,{alias:this.state.alias},'');
  }

  pageEvent = async () => {
    //get psp data
    const alias = localStorage.getItem('ALIAS')?localStorage.getItem('ALIAS'):null;
    const sellerId = localStorage.getItem('PSP_PRINCIPAL_ID')?localStorage.getItem('PSP_PRINCIPAL_ID'):null;
    this.setState({alias: alias})
    this.setState({sellerId: sellerId})
  }

  renderPage() {
    const alias = this.state.alias;
    return (
      <AppContent className="seller-items-page tw-bg-white" padded>
        <div className="pod-container tw-mt-8 tw-pr-5 tw-pl-5">
          <div className="tw-mt-12 tw-mb-8 tw-flex tw-items-center tw-justify-between">
            <Link className="tw-text-black tw-text-sm" to={`/seller/${alias}`}>
              <img
                src="/images/icons/icon-left.svg"
                alt="back"
                width="18" height="18"
              />&nbsp;&nbsp;&nbsp;&nbsp;
              <span className="tw-h-[18px] tw-text-sm">
                  Back to shop {this.state.alias?this.state.alias:'Someone\'s'}
                </span>
            </Link>
            <button style={{backgroundColor:'#6D60F6', borderRadius:'10px'}} className="tw-bg-[#6D60F6] tw-rounded-lg tw-border tw-border-white tw-py-2 tw-px-2 tw-text-white tw-flex-end md:tw-hidden"
                    onClick={(cta) => this.buttonCTA(cta,'/create-link')}>
              Become a seller &nbsp;
              <img
                src="/images/icons/right.svg"
                alt="shop"
                className="tw-h-[24px] tw-w-[24px]"
              />

            </button>
          </div>

          <div className="d-flex flex-column flex-md-row justify-content-between">
            <div style={{width:'75%'}} className="store-container tw-hidden md:tw-block tw-w-[75%] md:tw-pr-10">
              <div className="md:tw-pl-10">
                <p className="tw-font-semibold">Why POD</p>
                <span className="tw-mb-5">
                  <p className="tw-mb-5">Payondelivery.com (POD) gives you the advantage of accepting payment on delivery seamlessly via a simplified payment process. Selling on POD gives you a lot of advantages like:</p>
                  <ol>
                    <li>Managing logistic operations effortlessly: All you need to do is to tell us where to pick up the item the customer wants to buy and we will deliver to your customer. The delivery fee is paid by the customer.</li><br/>
                    <li>Getting free web store: Having a free store front where you can upload all your items for sale which enables you to reach more customers and grow your sales exponentially. With POD, you can ensure customers trust your brand, removing the hassle of the fear of "what i got, vs what i ordered". </li><br/>
                    <li>Escrow service: Building customers trust is a very important part of your brand and by removing the of the fear of "what i ordered, vs what i got", your customers can trust you and even refer you.</li><br/>
                    <li>Individual product link: For each product you create, you get a link that you can post and share particularly for that product. This allows for flexibility in many cases. Foe instance if you want to put one or two products on sales.</li><br/>
                    <li>Become a POD partner: Signing up as a seller with POD gives you the chance of becoming a <span className="tw-font-semibold tw-text-[#6D60F6]" onClick={(cta) => this.buttonCTA(cta,'/create-link')}>POD partner.</span></li><br/>
                  </ol>
                </span>
                <p className="tw-font-semibold">Get started in just 3 steps </p>
                <div className="d-flex flex-column tw-items-center flex-md-row justify-content-between">
                  <div style={{minWidth:'265px', minHeight:'259px', backgroundImage:"url('/images/ssp/file.png')"}} className="tw-min-w-[265px] sm:tw-w-full tw-min-h-[259px] md:tw-mr-5 sm:tw-mb-5 tw-bg-[url('/images/ssp/file.png')] tw-bg-no-repeat tw-bg-cover"></div>
                  <div style={{minWidth:'265px', minHeight:'259px', backgroundImage:"url('/images/ssp/step2.png')"}} className="tw-min-w-[265px] sm:tw-w-full tw-min-h-[259px] md:tw-mr-5 sm:tw-mb-5 tw-bg-[url('/images/ssp/step2.png')] tw-bg-no-repeat tw-bg-cover"></div>
                  <div style={{minWidth:'265px', minHeight:'259px', backgroundImage:"url('/images/ssp/step3.png')"}} className="tw-min-w-[265px] sm:tw-w-full tw-min-h-[259px] sm:tw-mb-5 tw-bg-[url('/images/ssp/step3.png')] tw-bg-no-repeat tw-bg-cover"></div>
                </div>
              </div>
            </div>
            <div style={{width:'96%'}} className="store-container md:tw-hidden tw-w-[75%] md:tw-pr-10">
              <div className="md:tw-pl-10">
                <p className="tw-font-semibold">Why POD</p>
                <span className="tw-mb-5">
                  <p className="tw-mb-5">Payondelivery.com (POD) gives you the advantage of accepting payment on delivery seamlessly via a simplified payment process. Selling on POD gives you a lot of advantages like:</p>
                  <ol>
                    <li>Managing logistic operations effortlessly: All you need to do is to tell us where to pick up the item the customer wants to buy and we will deliver to your customer. The delivery fee is paid by the customer.</li><br/>
                    <li>Getting free web store: Having a free store front where you can upload all your items for sale which enables you to reach more customers and grow your sales exponentially. With POD, you can ensure customers trust your brand, removing the hassle of the fear of "what i got, vs what i ordered". </li><br/>
                    <li>Escrow service: Building customers trust is a very important part of your brand and by removing the of the fear of "what i ordered, vs what i got", your customers can trust you and even refer you.</li><br/>
                    <li>Individual product link: For each product you create, you get a link that you can post and share particularly for that product. This allows for flexibility in many cases. Foe instance if you want to put one or two products on sales.</li><br/>
                    <li>Become a POD partner: Signing up as a seller with POD gives you the chance of becoming a <span className="tw-font-semibold tw-text-[#6D60F6]" onClick={(cta) => this.buttonCTA(cta,'/create-link')}>POD partner.</span></li><br/>
                  </ol>
                </span>
                <p className="tw-font-semibold">Get started in just 3 steps </p>
                <div className="d-flex flex-column tw-items-center flex-md-row justify-content-between">
                  <div style={{minWidth:'265px', minHeight:'259px', backgroundImage:"url('/images/ssp/file.png')"}} className="tw-min-w-[265px] sm:tw-w-full tw-min-h-[259px] md:tw-mr-5 sm:tw-mb-5 tw-bg-[url('/images/ssp/file.png')] tw-bg-no-repeat tw-bg-cover"></div>
                  <div style={{minWidth:'265px', minHeight:'259px', backgroundImage:"url('/images/ssp/step2.png')"}} className="tw-min-w-[265px] sm:tw-w-full tw-min-h-[259px] md:tw-mr-5 sm:tw-mb-5 tw-bg-[url('/images/ssp/step2.png')] tw-bg-no-repeat tw-bg-cover"></div>
                  <div style={{minWidth:'265px', minHeight:'259px', backgroundImage:"url('/images/ssp/step3.png')"}} className="tw-min-w-[265px] sm:tw-w-full tw-min-h-[259px] sm:tw-mb-5 tw-bg-[url('/images/ssp/step3.png')] tw-bg-no-repeat tw-bg-cover"></div>
                </div>
              </div>
            </div>
            <div className="added-item tw-hidden md:tw-block tw-mt-10">
              <h2 className="tw-mb-2 tw-text-lg tw-font-semibold tw-text-gray-900 tw-dark:text-white">Become a seller with POD</h2>
              <ul className="tw-list-image-[url('/images/icons/checkmark.png')]">
                <li className="tw-mb-5"> Fast and reliable</li>
                <li className="tw-mb-5"> Easy to use</li>
                <li className="tw-mb-5"> Free store front</li>
                <li className="tw-mb-5"> Free store link</li>
                <li className="tw-mb-5"> Free product links</li>
                <li className="tw-mb-5"> Escrow service</li>
              </ul>
              <button style={{backgroundColor:'#6D60F6', height:'45px'}} className="tw-w-full tw-h-[45px] tw-bg-[#6D60F6] tw-rounded-lg tw-border tw-border-white tw-text-white"
                      onClick={(cta) => this.buttonCTA(cta,'/create-link')}>
                Start selling on POD now&nbsp;&nbsp;
                <img
                  src="/images/icons/right.svg"
                  alt="shop"
                  style={{height:'24px', width:'24px'}}
                  className="tw-h-[24px] tw-w-[24px]"
                />
              </button>
            </div>
            <div className="added-item md:tw-hidden tw-mt-10">
              <button style={{height:'45px', backgroundColor:'#6D60F6'}} className="tw-w-full h-[45px] bg-[#6D60F6] tw-rounded-lg tw-border tw-border-white tw-text-white"
                      onClick={(cta) => this.buttonCTA(cta,'/create-link')}>
                Start selling on POD now&nbsp;&nbsp;
                <img
                  src="/images/icons/right.svg"
                  alt="shop"
                  style={{height:'24px', width:'24px'}}
                  className="tw-h-[24px] tw-w-[24px]"
                />

              </button>
            </div>
          </div>
        </div>
      </AppContent>
    )
  }
}
